// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__1SeQf","footer":"ReportModalFilter_footer__2sMii"};